import axios from "axios";

// Create an Axios instance
const api = axios.create({
    baseURL: "https://passport-api.govirtual.ph",
});


// Global response interceptor
api.interceptors.response.use(
    (response) => response,
    async (error) => {
        console.error("API error:", error);

        if (error.response) {
            const status = error.response.status;

            if (status === 401) {
                console.warn("Token expired or unauthorized. Redirecting...");
                window.location.href = "/register";
            }
        }

        return Promise.reject(error);
    }
);

export default api;